"use client";

import { c as _c } from "react/compiler-runtime";
import { CpvOut, LocationOut } from "@/client";
import { ApplyFiltersButton } from "@/components/filters/apply-button";
import { ComboboxFilter } from "@/components/filters/combobox-filter";
import { DateRangeFilter } from "@/components/filters/daterange-filter";
import { FilterProvider } from "@/components/filters/filter-context";
import { NumberRangeFilter } from "@/components/filters/numberrange-filter";
import { ResetFiltersButton } from "@/components/filters/reset-button";
import { TenderStatus } from "@/components/status-badge";
import { Label } from "@/components/ui/label";
import { startOfDay } from "date-fns";
import { BadgeEuro, BatteryMedium, Briefcase, Building2, CalendarCheckIcon, CalendarClockIcon, FileCode, FileText, Hash, LucideIcon, MapPin } from "lucide-react";
interface FilterPanelProps {
  statuses: string[];
  locations: LocationOut[];
  authorities: string[];
  types: string[];
  subtypes: string[];
  procedures: string[];
  cpvs: CpvOut[];
}
function FilterItem(t0) {
  const $ = _c(8);
  const {
    icon: Icon,
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon className="mr-1 inline size-4" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <Label>{t1}{label}</Label>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <div className="space-y-2">{t2}{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export function FilterPanel(t0) {
  const $ = _c(37);
  const {
    statuses,
    locations,
    authorities,
    types,
    subtypes,
    procedures,
    cpvs
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full justify-end space-x-2 px-1"><ResetFiltersButton /><ApplyFiltersButton /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [TenderStatus.ONGOING, TenderStatus.ANNOUNCED];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== statuses) {
    t3 = <FilterItem icon={BatteryMedium} label="Estado"><ComboboxFilter id="status" data={statuses} placeholder="Seleccionar estado" defaultValue={t2} uppercase={true} /></FilterItem>;
    $[2] = statuses;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FilterItem icon={CalendarClockIcon} label={"Fecha l\xEDmite"}><DateRangeFilter id="deadline" defaultFrom={startOfDay(new Date())} /></FilterItem>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== locations) {
    t5 = locations.map(_temp);
    $[5] = locations;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== locations) {
    t6 = locations.map(_temp2);
    $[7] = locations;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <FilterItem icon={MapPin} label={"Ubicaci\xF3n"}><ComboboxFilter id="location" data={t5} displayData={t6} placeholder={"Seleccionar ubicaci\xF3n"} /></FilterItem>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== authorities) {
    t8 = <FilterItem icon={Building2} label="Entidad contratante"><ComboboxFilter id="authority" data={authorities} placeholder="Seleccionar entidad" /></FilterItem>;
    $[12] = authorities;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== procedures) {
    t9 = <FilterItem icon={FileText} label="Procedimiento"><ComboboxFilter id="procedure" data={procedures} placeholder="Seleccionar procedimiento" /></FilterItem>;
    $[14] = procedures;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FilterItem icon={CalendarCheckIcon} label={"Fecha de publicaci\xF3n"}><DateRangeFilter id="published" /></FilterItem>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== types) {
    t11 = <FilterItem icon={Briefcase} label="Tipo"><ComboboxFilter id="type" data={types} placeholder="Seleccionar tipo" /></FilterItem>;
    $[17] = types;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== subtypes) {
    t12 = <FilterItem icon={FileCode} label="Subtipo"><ComboboxFilter id="subtype" data={subtypes} placeholder="Seleccionar subtipo" /></FilterItem>;
    $[19] = subtypes;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== cpvs) {
    t13 = cpvs.map(_temp3);
    $[21] = cpvs;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== cpvs) {
    t14 = cpvs.map(_temp4);
    $[23] = cpvs;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <FilterItem icon={Hash} label={"C\xF3digo CPV"}><ComboboxFilter id="cpvs" data={t13} displayData={t14} placeholder="Seleccionar CPV" /></FilterItem>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FilterItem icon={BadgeEuro} label="Presupuesto"><NumberRangeFilter id="budget" minPlaceholder={"M\xEDnimo"} maxPlaceholder={"M\xE1ximo"} step={1} /></FilterItem>;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t15 || $[32] !== t3 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t17 = <FilterProvider><div className="grid gap-5 p-4">{t1}{t3}{t4}{t7}{t8}{t9}{t10}{t11}{t12}{t15}{t16}</div></FilterProvider>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t15;
    $[32] = t3;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
function _temp4(cpv_0) {
  return `${cpv_0.code} - ${cpv_0.name}`;
}
function _temp3(cpv) {
  return cpv.code;
}
function _temp2(location_0) {
  return `${location_0.code} - ${location_0.name}`;
}
function _temp(location) {
  return location.code;
}